import { AVATAR_SOURCES } from '../lib/AvatarSources';
const CONTACT_TYPES = new Set(['contact', 'vid', 'email', 'emails', 'enrichmentEmail']);
const COMPANY_TYPES = new Set(['company', 'companyId', 'domain', 'enrichmentDomain']);
const PRODUCT_TYPES = new Set(['productId']);
function getSourceCategory(lookupType) {
  if (CONTACT_TYPES.has(lookupType)) return 'contact';
  if (COMPANY_TYPES.has(lookupType)) return 'company';
  if (PRODUCT_TYPES.has(lookupType)) return 'product';
  return 'unknown';
}
const SOURCE_MAP = {
  DEFAULT: {
    contact: AVATAR_SOURCES.CONTACT_DEFAULT,
    company: AVATAR_SOURCES.COMPANY_DEFAULT,
    product: AVATAR_SOURCES.PRODUCT_DEFAULT,
    unknown: AVATAR_SOURCES.UNKNOWN
  },
  OVERRIDE: {
    contact: AVATAR_SOURCES.CONTACT_OVERRIDE,
    company: AVATAR_SOURCES.COMPANY_OVERRIDE,
    product: AVATAR_SOURCES.PRODUCT_OVERRIDE,
    unknown: AVATAR_SOURCES.UNKNOWN
  },
  ENRICHMENT: {
    contact: AVATAR_SOURCES.CONTACT_ENRICHMENT,
    company: AVATAR_SOURCES.COMPANY_ENRICHMENT,
    product: AVATAR_SOURCES.UNKNOWN,
    unknown: AVATAR_SOURCES.UNKNOWN
  },
  INHERITED_OVERRIDE: {
    contact: AVATAR_SOURCES.CONTACT_OVERRIDE,
    company: AVATAR_SOURCES.UNKNOWN,
    product: AVATAR_SOURCES.UNKNOWN,
    unknown: AVATAR_SOURCES.UNKNOWN
  },
  INHERITED_ENRICHMENT: {
    contact: AVATAR_SOURCES.CONTACT_ENRICHMENT,
    company: AVATAR_SOURCES.UNKNOWN,
    product: AVATAR_SOURCES.UNKNOWN,
    unknown: AVATAR_SOURCES.UNKNOWN
  }
};
export function mapRpcAvatarSource(rpcSource, lookupType) {
  var _SOURCE_MAP$rpcSource, _SOURCE_MAP$rpcSource2;
  if (!lookupType) return AVATAR_SOURCES.UNKNOWN;
  const category = getSourceCategory(lookupType);
  return (_SOURCE_MAP$rpcSource = (_SOURCE_MAP$rpcSource2 = SOURCE_MAP[rpcSource]) === null || _SOURCE_MAP$rpcSource2 === void 0 ? void 0 : _SOURCE_MAP$rpcSource2[category]) !== null && _SOURCE_MAP$rpcSource !== void 0 ? _SOURCE_MAP$rpcSource : AVATAR_SOURCES.UNKNOWN;
}